var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DOT_TYPE } from "../common";
import { IBrushType, PenEventName, PEN_STATE } from "../common/enums";
import { NEO_SMARTPEN_TYPE } from "../common/neopen/INeoSmartpen";
import { isPlatePaper } from "../common/noteserver/SurfaceInfo";
import { InkStorage } from "../common/penstorage";
import { NeoDot } from "../common/structures";
import SmartPenBase from "./SmartPenBase";
// const NUM_HOVER_POINTERS = 6;
export default class RemotePen extends SmartPenBase {
    /**
     * Creates an instance of RemotePen.
     * @param {string} networkId
     * @param {string} mac
     * @memberof RemotePen
     */
    constructor(networkId, mac) {
        super(undefined, networkId, mac);
        /**
         *
         *
         * @memberof RemotePen
         */
        this.getBtDevice = () => {
            return undefined;
        };
        this.getMac = () => {
            return this.mac;
        };
        /**
         *
         *
         * @return {*}  {Promise<boolean>}
         * @memberof RemotePen
         */
        this.connect = (requestOnlineDataOnConencted = true) => __awaiter(this, void 0, void 0, function* () {
            this.dispatcher.dispatch(PenEventName.ON_CONNECTED, {
                inputType: this.inputType,
                pen: this,
                mac: this.mac,
                event: undefined
            });
            return true;
        });
        /**
         *
         *
         * @param {BluetoothDevice} device
         * @memberof RemotePen
         */
        this.connectByWebBtDevice = (device) => __awaiter(this, void 0, void 0, function* () {
            throw new Error(`connectByWebBtDevice: remote pen has not been implemented.`);
        });
        /**
         *
         *
         * @memberof RemotePen
         */
        this.disconnect = () => {
            this.dispatcher.dispatch(PenEventName.ON_DISCONNECTED, {
                inputType: this.inputType,
                pen: this,
                mac: this.getMac(),
            });
            // throw new Error(`disconnecting remote pen has not been implemented.`);
        };
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onPenDown = (event) => {
            throw new Error("Network pen does not support onPenDown");
        };
        /**
         *
         *
         * @private
         * @param {INetworkPacket} p - { strokeStartTime, strokeProps: { brushType, thickness, color} }
         * @memberof NetworkPen
         */
        this.processNetworkPenDown = (p) => {
            // const penDownStrokeInfo = this.processNetworkPenDown(p);
            const mac = p.mac;
            const time = p.strokeStartTime;
            // 원래 있던 코드
            let { brushType, thickness, color } = p.strokeProps;
            let penTipMode = p.strokeProps.brushType === IBrushType.ERASER ? 1 : 0;
            // 2021/06/20, remote 속성을 강제로 덮어써서 컨트롤 하려고 하는 경우를 대비해서
            if (this.overrideRemoteBrushType) {
                penTipMode = this.penRendererType === IBrushType.ERASER ? 1 : 0;
                brushType = this.penRendererType;
                thickness = this.penState[this.penRendererType].thickness;
                color = this.penState[this.penRendererType].color;
            }
            const originalKey = p.originalStrokeKey ? p.originalStrokeKey : p.strokeKey;
            const openStrokeArg = {
                // uuid: originalKey,
                mac,
                time,
                penTipMode,
                brushType,
                thickness,
                color,
                inputType: this.inputType,
                writerId: p.writerId,
                surfaceOwnerId: p.surfaceOwnerId,
                originalKey,
                fromNetworkPen: true
            };
            const stroke = this.storage.openStroke(openStrokeArg);
            const strokeKey = stroke.key;
            this.currPenMovement.stroke = stroke;
            return { strokeKey, mac, time, stroke };
        };
        /**
         *
         *
         * @param {INetworkPacket} p
         *    {
         *        type, webBluetoothId, mac, strokeKey, strokeStartTime,
         *        strokeProps: {thickness, brushType, color, status }
         *    }
         * @memberof RemotePen
         */
        this.onNetworkPenDown = (p) => {
            // event: { timeStamp: number, penTipMode: number, mac }
            this.resetPenStroke();
            this.lastState = PEN_STATE.PEN_DOWN;
            this.setColor(p.strokeProps.color);
            const penDownStrokeInfo = this.processNetworkPenDown(p);
            // dispatch event
            // console.log(`NeoSmartpen dispatch event ON_PEN_DOWN`);
            this.dispatcher.dispatch(PenEventName.ON_PEN_DOWN, Object.assign(Object.assign({}, penDownStrokeInfo), { pen: this, inputType: this.inputType }));
            this.manager.setActivePen(this.mac);
        };
        this.super_onPageInfo = this.onPageInfo;
        /**
         * 펜의 움직임
         *    1) down/up이 있는 경우: DOWN -> INFO -> MOVE -> MOVE -> ... -> UP -> INFO와 같이 나옴
         *    2) hove의 경우: (페이지가 바뀌면) INFO -> HOVER_MOVE -> HOVER_MOVE...
         *
         * pen down 된 후의 page info, 실질적으로 pen_down과 같음
         *
         * @param {IPenCommEvent} event
         * @param {boolean} hover
         * @memberof RemotePen
         */
        this.onPageInfo = (event, hover) => {
            event.fromNetworkPen = true;
            // super.onPageInfo(event, hover);
            this.super_onPageInfo(event, hover);
        };
        this.super_onPenMove = this.onPenMove;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onPenMove = (event) => {
            event.fromNetworkPen = true;
            // super.onPenMove(event);
            this.super_onPenMove(event);
        };
        this.super_onHoverMove = this.onHoverMove;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onHoverMove = (event) => {
            event.fromNetworkPen = true;
            // super.onHoverMove(event);
            this.super_onHoverMove(event);
        };
        this.super_onHoverPageInfo = this.onHoverPageInfo;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onHoverPageInfo = (event) => {
            event.fromNetworkPen = true;
            // super.onHoverPageInfo(event);
            this.super_onHoverPageInfo(event);
        };
        this.super_onPenUp = this.onPenUp;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onPenUp = (event) => {
            event.fromNetworkPen = true;
            // super.onPenUp(event);
            this.super_onPenUp(event);
        };
        this.super_onNcodeError = this.onNcodeError;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onNcodeError = (event) => {
            event.fromNetworkPen = true;
            // super.onNcodeError(event);
            this.super_onNcodeError(event);
        };
        this.super_onPasscodeRequired = this.onPasscodeRequired;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onPasscodeRequired = (event) => {
            event.fromNetworkPen = true;
            // super.onPasscodeRequired(event);
            this.super_onPasscodeRequired(event);
        };
        this.super_onConnected = this.onConnected;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onConnected = (event) => {
            event.fromNetworkPen = true;
            // super.onConnected(event);
            this.super_onConnected(event);
        };
        this.super_onFirmwareUpgradeNeeded = this.onFirmwareUpgradeNeeded;
        /**
         *
         *
         * @param {IPenCommEvent} event
         * @memberof RemotePen
         */
        this.onFirmwareUpgradeNeeded = (event) => {
            event.fromNetworkPen = true;
            // super.onFirmwareUpgradeNeeded(event);
            this.super_onFirmwareUpgradeNeeded(event);
        };
        /**
         *
         *
         * @param {INetworkPacket} p
         * @memberof RemotePen
         */
        this.onStrokeReceived = (p) => {
            this.resetPenStroke();
            // 2021/06/27
            // OnTheLine에서는 중복된 stroke가 들어오는 경우가 있다.
            if (this.storage.hasOriginalKeyStroke(p.strokeKey))
                return;
            // 2021/08/04 Network Pen의 plate에는 반응하지 않도록 한다.
            // 이미 스트로크에 반영되어 있는 상태이다.
            const isOnPlate = isPlatePaper(p.pageInfo);
            if (isOnPlate) {
                return;
            }
            if (isOnPlate)
                p.strokeProps.brushType = IBrushType.PUI;
            const { section, owner, book, page } = p.pageInfo;
            // PEN DOWN
            const st = this.processNetworkPenDown(p);
            // PAGE INFO
            this.storage.setStrokeInfo(st.strokeKey, section, owner, book, page, p.strokeStartTime);
            // DOTS
            p.dots.forEach(d => {
                const dot = new NeoDot(Object.assign(Object.assign({}, d), { dotType: DOT_TYPE.penmove }));
                this.storage.appendDot(st.strokeKey, dot);
            });
            // PEN_UP
            this.storage.closeStrokeNetwork(st.strokeKey);
            // 2021/07/06 삭제, 대신 위의 한 줄
            // PEN_UP
            // this.storage.closeStroke(st.strokeKey);
            // event
            // this.dispatcher.dispatch(PenEventName.ON_STROKE_RECEIVED,
            //   {
            //     stroke: st.stroke,
            //     strokeKey: st.strokeKey,
            //     inputType: this.inputType,
            //     mac: this.mac,
            //     pen: this,
            //     section, owner, book, page
            //   } as IPenToViewerEvent
            // );
        };
        this.inputType = RemotePen.getInputType();
        this.connected = true;
        this.protocolHandler = null;
        this.storage = InkStorage.getInstance();
        const color = this.manager.color;
        for (let i = 0, l = this.penState.length; i < l; i++) {
            this.penState[i] = {
                thickness: 0.2,
                color: color,
            };
        }
        this.mac = mac;
        this.webBluetoothId = networkId;
    }
    static getInputType() {
        return NEO_SMARTPEN_TYPE.NETWORK_PEN;
    }
}
//# sourceMappingURL=RemotePen.js.map